/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useImperativeHandle, useState, forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Skeleton from '@mui/material/Skeleton';

// styles
const boxStyles = {
  position: 'relative'
};
const skeletonStyles = {
  position: 'absolute',
  height: '40px',
  width: '100%',
  borderRadius: '5px',
  top: 0,
  left: 0
};

export const VpStripeInput = (props) => {
  const {
    helperText,
    InputLabelProps,
    InputProps = {},
    inputProps,
    stripeElement,
    options,
    ...other
  } = props;
  const [isReady, setIsReady] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onChange = (e) => {
    setErrorMessage(e?.error?.message);
  };
  const onReady = () => {
    setIsReady(true);
  };

  return (
    <Box sx={boxStyles}>
      {!isReady && <Skeleton animation="wave" sx={skeletonStyles} variant="rectangular" />}
      <TextField
        sx={{
          '& .__PrivateStripeElement': {
            top: '2px',
            position: 'relative'
          }
        }}
        fullWidth
        size="small"
        variant="outlined"
        onChange={onChange}
        InputLabelProps={{
          ...InputLabelProps
        }}
        error={!!errorMessage}
        InputProps={{
          ...InputProps,
          inputProps: {
            ...inputProps,
            ...InputProps.inputProps,
            component: stripeElement,
            onReady,
            options: options
          },
          inputComponent: StripeInput
        }}
        helperText={errorMessage ? errorMessage : helperText || <span>&nbsp;</span>}
        {...other}
      />
    </Box>
  );
};

const StripeInput = forwardRef(function StripeInput(props, ref) {
  const { component: Component, options, ...other } = props;
  const theme = useTheme();
  const [mountNode, setMountNode] = useState(null);

  useImperativeHandle(
    ref,
    () => ({
      focus: () => mountNode.focus()
    }),
    [mountNode]
  );

  return (
    <Component
      onReady={setMountNode}
      options={{
        ...options,
        style: {
          base: {
            fontSize: '16px',
            fontFamily: 'Roboto, sans-serif',
            '::placeholder': {
              color: theme.palette.vpColors.grey
            }
          },
          invalid: {
            color: theme.palette.error.main
          }
        }
      }}
      {...other}
    />
  );
});



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpStripeInput.jsx